export default "__VITE_ASSET__9830ca45__"